export default __webpack_public_path__ + "static/hero-video-1-87dc31ee9b7bae06b815cd206191cb76.mp4";